import { render } from "./ApplicationView.vue?vue&type=template&id=06f13c78"
import script from "./ApplicationView.vue?vue&type=script&lang=js"
export * from "./ApplicationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__